import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

// IMAGES IMPORT LINK
import singleImg08 from "./../assets/AyurvedaAssets/images/single-img-08.png";
import service01 from "./../assets/AyurvedaAssets/images/services/service-01.png";
import icon05 from "./../assets/AyurvedaAssets/images/icon-05.svg";

export default function TherapiesTreatments() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // default animation duration
      once: true, // whether animation should happen only once
    });
  }, []);
  return (
    <>
      {/* page-title */}
      <div className="prt-page-title-row style3">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-6 col-lg-8 col-md-10 col-sm-9 ms-auto"></div>
            </div>
          </div>
        </div>
      </div>
      {/* page-title end */}

      {/* site-main start */}
      <div className="site-main">
        {/* aboutservice-section1 */}
        <section className="prt-row padding_zero-section aboutservice-section clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-bg bg-base-grey aboutservice-block mt_135">
                  <div className="row">
                    <div className="col-lg-11 col-md-12 m-auto">
                      <div className="aboutservice-content">
                        <h3 className="title">Bharat Dhara – Panchkarma & Healing Therapies</h3>
                        <p className="desc">
                          Consectetur adipisicing elit, sed do eiusmod tempor
                          incididunt ut labore et dolore magna aliqua. Ut enim
                          ad minim veniam, quis nostrud exercitation ullamco
                          laboris nisi ut aliquip ex ea commodo consequat. Duis
                          aute irure dolor in reprehenderit. adipisicing elit,
                          sed do eiusmod tempor incididunt ut labore et dolore
                          magna aliqua. Ut enim ad minim veniam, quis nostrud
                          exercitation ullamco.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* aboutservice-section1 end */}
        {/* aboutservice-section2 */}
        <section className="prt-row padding_zero-section aboutservice-section clearfix" style={{ marginTop: "60px" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-bg bg-base-grey aboutservice-block">
                  <div className="row">
                    <div className="col-lg-11 col-md-12 m-auto">
                      <div className="aboutservice-content">
                        <h3 className="title">Panchkarma </h3>
                        <p className="desc">
                          Consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                          Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                          Duis aute irure dolor in reprehenderit.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* aboutservice-section2 end */}
        {/* about-section */}
        <section className="prt-row padding_bottom_zero-section about-section02 animation clearfix">
          <div className="container">
            <div className="row align-items-center">
              {/* FULL-WIDTH TITLE ROW */}
              <div className="row">
                <div className="col-12">
                  <div className="section-title text-center">
                    <div className="title-header">
                      <h2 className="title">Panchkarma: Preparatory Therapies</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12">
                <div>
                  {/* section title */}
                  <div className="section-title">
                    {/*<div className="title-header">
                      <h2 className="title">
                        Panchkarma:Preparatory Therapies
                      </h2>
                    </div>*/}
                    <div className="title-desc">
                      <h3 className="title">1. पूर्वकर्म (Poorva Karma – Preparatory Therapies)</h3>
                      <p>
                        <i>(These prepare the body for Panchkarma by loosening toxins and opening channels.)</i><br></br>
                        • <b>स्नेहन (Snehana)</b> – Oleation therapy, internal & external oiling.<br></br>
                        • <b>स्वेदन (Swedana)</b> – Sudation / steam bath to induce sweating.<br></br>
                        &nbsp;&nbsp;&nbsp;• <b>Steam Bath / Steam Box (Bashpa Sweda)</b> – Full-body steam therapy.<br></br>
                        &nbsp;&nbsp;&nbsp;• <b>मड्डी पट्टी (Maddi Patti)</b> – Herbal poultice / mud pack for pain & detox.<br></br>
                        • <b>अभ्यंग (Abhyanga)</b> – Full-body Ayurvedic oil massage.<br></br>
                        • <b>शिरोधारा (Shirodhara)</b> – Continuous pouring of medicated liquid on forehead.<br></br>
                        &nbsp;&nbsp;&nbsp;• जल शिरोधारा – Water-based.<br></br>
                        &nbsp;&nbsp;&nbsp;• तिल शिरोधारा – Sesame oil.<br></br>
                        &nbsp;&nbsp;&nbsp;• घृत शिरोधारा – Ghee.<br></br>
                        &nbsp;&nbsp;&nbsp;• पंचगव्य शिरोधारा – Panchagavya (cow-based).<br></br>
                        &nbsp;&nbsp;&nbsp;• तक्र शिरोधारा – Buttermilk.<br></br>
                        • <b>कटी बस्ति (Kati Basti)</b> – Warm oil pooling on lower back.<br></br>
                        • <b>जानु बस्ति (Janu Basti)</b> – Warm oil pooling on knee joints.<br></br>
                        • <b>ग्रीवा बस्ति (Griva Basti)</b> – Warm oil pooling on neck.<br></br>
                        • <b>नाभि बस्ति (Nabhi Basti)</b> – Warm oil pooling on navel.<br></br>
                        • <b>हृदि बस्ति (Hridi Basti)</b> – Warm oil pooling on cardiac region.<br></br>
                        • <b>अक्षि वस्ति (Akshi Vasti / Netra Tarpana)</b> – Eye rejuvenation with ghee.<br></br>
                        • <b>पाद अभ्यंग (Pada Abhyanga)</b> – Foot massage for relaxation & circulation.<br></br>
                        • <b>ठंडा / गर्म पट्टी (Cold/Hot Compress)</b> – Pain & inflammation relief.<br></br>
                        • <b>ठंडा / गर्म सेक (Cold/Hot Fomentation)</b> – Local sudation for stiffness/pain.<br></br>
                      </p>
                    </div>
                  </div>
                  {/* section title end 
                  <ul className="prt-list prt-list-style-icon-03">
                    <li className="prt-list-li-content">
                      Sed do eiusmod tempor incididunt ut labore et dolore magna{" "}
                    </li>
                    <li className="prt-list-li-content">
                      Ut enim ad minim veniam, quis nostrud exercitation
                    </li>
                    <li className="prt-list-li-content">
                      Laboris nisi ut aliquip ex ea commodo consequat duis{" "}
                    </li>
                    <li className="prt-list-li-content">
                      dolor in reprehenderit in voluptate velit esse cillum
                      dolore
                    </li>
                  </ul>*/}
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12">
                {/* prt_single_image-wrapper */}
                <div className="prt_single_image-wrapper text-center res-1199-mt-30 faderight-anim">
                  <img
                    width="635"
                    height="500"
                    className="img-fluid border-rad_10"
                    src={singleImg08}
                    alt="image"
                  />
                </div>
                {/* prt_single_image-wrapper end */}
              </div>
            </div>
          </div>
        </section>
        {/* about-section end */}
        {/* about-section */}
        <section className="prt-row padding_bottom_zero-section about-section02 animation clearfix">
          <div className="container">
            <div className="row align-items-center">
              {/* FULL-WIDTH TITLE ROW */}
              <div className="row">
                <div className="col-12">
                  <div className="section-title text-center">
                    <div className="title-header">
                      <h2 className="title"> Panchkarma:Main Therapies</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12">
                <div>
                  {/* section title */}
                  <div className="section-title">
                    {/*<div className="title-header">
                      <h2 className="title">
                        Panchkarma:Main Therapies
                       </h2>
                    </div>*/}
                    <div className="title-desc">
                      <h3 className="title">2. प्रधानकर्म (Pradhan Karma – Main Panchkarma)</h3>
                      <p>
                        <i>(Core five detox therapies to eliminate deep-rooted toxins.)</i><br></br>
                        • <b>वमन (Vamana)</b> – Therapeutic emesis to remove Kapha toxins.<br></br>
                        • <b>विरेचन (Virechana)</b> – Purgation therapy to balance Pitta.<br></br>
                        • <b>बस्ति (Basti)</b> – Medicated enema therapy for Vata balance.<br></br>
                        &nbsp;&nbsp;&nbsp;• अनुवासन बस्ति – Oil enema.<br></br>
                        &nbsp;&nbsp;&nbsp;• निरूह बस्ति – Decoction enema.<br></br>
                        &nbsp;&nbsp;&nbsp;• योग बस्ति – Combination protocol.<br></br>
                        • <b>नस्य (Nasya)</b> – Nasal medication for head, neck & sinus health.<br></br>
                        • <b>रक्तमोक्षण (Raktamokshana)</b> – Bloodletting for purification.<br></br>
                      </p>
                    </div>
                  </div>
                  {/* section title end 
                  <ul className="prt-list prt-list-style-icon-03">
                    <li className="prt-list-li-content">
                      Sed do eiusmod tempor incididunt ut labore et dolore magna{" "}
                    </li>
                    <li className="prt-list-li-content">
                      Ut enim ad minim veniam, quis nostrud exercitation
                    </li>
                    <li className="prt-list-li-content">
                      Laboris nisi ut aliquip ex ea commodo consequat duis{" "}
                    </li>
                    <li className="prt-list-li-content">
                      dolor in reprehenderit in voluptate velit esse cillum
                      dolore
                    </li>
                  </ul>*/}
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12">
                {/* prt_single_image-wrapper */}
                <div className="prt_single_image-wrapper text-center res-1199-mt-30 faderight-anim">
                  <img
                    width="635"
                    height="500"
                    className="img-fluid border-rad_10"
                    src={singleImg08}
                    alt="image"
                  />
                </div>
                {/* prt_single_image-wrapper end */}
              </div>
            </div>
          </div>
        </section>
        {/* about-section end */}
        {/* about-section */}
        <section className="prt-row padding_bottom_zero-section about-section02 animation clearfix">
          <div className="container">
            <div className="row align-items-center">
              {/* FULL-WIDTH TITLE ROW */}
              <div className="row">
                <div className="col-12">
                  <div className="section-title text-center">
                    <div className="title-header">
                      <h2 className="title"> Panchkarma:Post Procedures</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12">
                <div>
                  {/* section title */}
                  <div className="section-title">
                    {/*<div className="title-header">
                      <h2 className="title">
                        Panchkarma:Post Procedures
                       </h2>
                    </div>*/}
                    <div className="title-desc">
                      <h3 className="title">3. पश्चात्कर्म (Paschat Karma – Post Procedures)</h3>
                      <p>
                        <i>(For recovery, rejuvenation & lifestyle correction after Panchkarma.)</i><br></br>
                        • <b>संसर्जन क्रमा (Sansarjana Krama)</b> – Special light diet after detox.<br></br>
                        • <b>रसयान चिकित्सा (Rasayana Chikitsa)</b> – Rejuvenation & anti-aging therapy.<br></br>
                        • <b>जीवन शैली परामर्श (Lifestyle Guidance)</b> – Yoga, Pranayama, diet & meditation.<br></br>
                      </p>
                    </div>
                  </div>
                  {/* section title end 
                  <ul className="prt-list prt-list-style-icon-03">
                    <li className="prt-list-li-content">
                      Sed do eiusmod tempor incididunt ut labore et dolore magna{" "}
                    </li>
                    <li className="prt-list-li-content">
                      Ut enim ad minim veniam, quis nostrud exercitation
                    </li>
                    <li className="prt-list-li-content">
                      Laboris nisi ut aliquip ex ea commodo consequat duis{" "}
                    </li>
                    <li className="prt-list-li-content">
                      dolor in reprehenderit in voluptate velit esse cillum
                      dolore
                    </li>
                  </ul>*/}
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12">
                {/* prt_single_image-wrapper */}
                <div className="prt_single_image-wrapper text-center res-1199-mt-30 faderight-anim">
                  <img
                    width="635"
                    height="500"
                    className="img-fluid border-rad_10"
                    src={singleImg08}
                    alt="image"
                  />
                </div>
                {/* prt_single_image-wrapper end */}
              </div>
            </div>
          </div>
        </section>
        {/* about-section end */}

        {/* aboutservice-section3 */}
        <section className="prt-row padding_zero-section aboutservice-section clearfix" style={{ marginTop: "200px" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-bg bg-base-grey aboutservice-block mt_135">
                  <div className="row">
                    <div className="col-lg-11 col-md-12 m-auto">
                      <div className="aboutservice-content">
                        <h3 className="title">Bharat Dhara – Special Ayurvedic Therapies</h3>
                        <p className="desc">
                          Consectetur adipisicing elit, sed do eiusmod tempor
                          incididunt ut labore et dolore magna aliqua. Ut enim
                          ad minim veniam, quis nostrud exercitation ullamco
                          laboris nisi ut aliquip ex ea commodo consequat. Duis
                          aute irure dolor in reprehenderit. adipisicing elit,
                          sed do eiusmod tempor incididunt ut labore et dolore
                          magna aliqua. Ut enim ad minim veniam, quis nostrud
                          exercitation ullamco.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* aboutservice-section3 end */}
        {/* about-section 1*/}
        <section className="prt-row padding_bottom_zero-section about-section02 animation clearfix">
          <div className="container">
            <div className="row align-items-center">
              {/* FULL-WIDTH TITLE ROW */}
              <div className="row">
                <div className="col-12">
                  <div className="section-title text-center">
                    <div className="title-header">
                      <h2 className="title"> Bharat Dhara – Special Ayurvedic Therapies</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12">
                <div>
                  {/* section title */}
                  <div className="section-title">
                    {/*<div className="title-header">
                      <h2 className="title">
                       विशेष आयुर्वेदिक चिकित्सा (Special Ayurvedic Therapies)
                       </h2>
                    </div>*/}
                    <div className="title-desc">
                      <h3 className="title">विशेष आयुर्वेदिक चिकित्सा (Special Ayurvedic Therapies)</h3>
                      <p>
                        • <b>दशविध परीक्षण (Dashvidha Parikshan)</b> – Tenfold diagnostic evaluation.<br></br>
                        • <b>मर्म चिकित्सा (Marma Chikitsa)</b> – Energy/vital point therapy.<br></br>
                        • <b>जल चिकित्सा (Hydrotherapy)</b> – Water-based healing methods.<br></br>
                        • <b>फुट डिटॉक्स थैरेपी (Foot Detox Therapy)</b> – Toxin elimination through feet.<br></br>
                      </p>
                    </div>
                  </div>
                  {/* section title end 
                  <ul className="prt-list prt-list-style-icon-03">
                    <li className="prt-list-li-content">
                      Sed do eiusmod tempor incididunt ut labore et dolore magna{" "}
                    </li>
                    <li className="prt-list-li-content">
                      Ut enim ad minim veniam, quis nostrud exercitation
                    </li>
                    <li className="prt-list-li-content">
                      Laboris nisi ut aliquip ex ea commodo consequat duis{" "}
                    </li>
                    <li className="prt-list-li-content">
                      dolor in reprehenderit in voluptate velit esse cillum
                      dolore
                    </li>
                  </ul>*/}
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12">
                {/* prt_single_image-wrapper */}
                <div className="prt_single_image-wrapper text-center res-1199-mt-30 faderight-anim">
                  <img
                    width="635"
                    height="500"
                    className="img-fluid border-rad_10"
                    src={singleImg08}
                    alt="image"
                  />
                </div>
                {/* prt_single_image-wrapper end */}
              </div>
            </div>
          </div>
        </section>
        {/* about-section1 end */}
        {/* aboutservice-section4 */}
        <section className="prt-row padding_zero-section aboutservice-section clearfix" style={{ marginTop: "200px" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-bg bg-base-grey aboutservice-block mt_135">
                  <div className="row">
                    <div className="col-lg-11 col-md-12 m-auto">
                      <div className="aboutservice-content">
                        <h3 className="title">Exclusive Bharat Dhara Therapies</h3>
                        <p className="desc">
                          Consectetur adipisicing elit, sed do eiusmod tempor
                          incididunt ut labore et dolore magna aliqua. Ut enim
                          ad minim veniam, quis nostrud exercitation ullamco
                          laboris nisi ut aliquip ex ea commodo consequat. Duis
                          aute irure dolor in reprehenderit. adipisicing elit,
                          sed do eiusmod tempor incididunt ut labore et dolore
                          magna aliqua. Ut enim ad minim veniam, quis nostrud
                          exercitation ullamco.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* aboutservice-section4 end */}
        {/* about-section 2*/}
        <section className="prt-row padding_bottom_zero-section about-section02 animation clearfix">
          <div className="container">
            <div className="row align-items-center">
              {/* FULL-WIDTH TITLE ROW */}
              <div className="row">
                <div className="col-12">
                  <div className="section-title text-center">
                    <div className="title-header">
                      <h2 className="title"> Exclusive Bharat Dhara Therapies</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12">
                <div>
                  {/* section title */}
                  <div className="section-title">
                    {/*<div className="title-header">
                      <h2 className="title">
                       विशेष आयुर्वेदिक चिकित्सा (Special Ayurvedic Therapies)
                       </h2>
                    </div>*/}
                    <div className="title-desc">
                      <h3 className="title">विशेष आयुर्वेदिक चिकित्सा (Special Ayurvedic Therapies)</h3>
                      <p>
                        <b>विशेषीकृत चिकित्सा (Specialized Bharat Dhara Therapies)</b><br></br>
                        • <b>Varicose Veins Specialized Therapy</b> – For vein health & circulation.<br></br>
                        • <b>Body Alignment Therapy</b> – Posture & musculoskeletal correction.<br></br>
                        • <b>Upper Limb Node Therapy</b> – Specialized therapy for arms.<br></br>
                        • <b>Lower Limb Node Therapy (Pada Abhyanga)</b> – Specialized therapy for legs/feet.<br></br>
                        • <b>Lower Limb Node Therapy (Pada Abhyanga)</b> – Specialized therapy for legs/feet.नाभि संस्थापन चिकित्सा (Nabhi Sansthapana Chikitsa – Umbilical Realignment Therapy) – Traditional Ayurvedic method to correct umbilical displacement, improve digestion, relieve abdominal discomfort, balance Vata, and strengthen Agni (digestive fire).<br></br>
                      </p>

                    </div>
                  </div>
                  {/* section title end 
                  <ul className="prt-list prt-list-style-icon-03">
                    <li className="prt-list-li-content">
                      Sed do eiusmod tempor incididunt ut labore et dolore magna{" "}
                    </li>
                    <li className="prt-list-li-content">
                      Ut enim ad minim veniam, quis nostrud exercitation
                    </li>
                    <li className="prt-list-li-content">
                      Laboris nisi ut aliquip ex ea commodo consequat duis{" "}
                    </li>
                    <li className="prt-list-li-content">
                      dolor in reprehenderit in voluptate velit esse cillum
                      dolore
                    </li>
                  </ul>*/}
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12">
                {/* prt_single_image-wrapper */}
                <div className="prt_single_image-wrapper text-center res-1199-mt-30 faderight-anim">
                  <img
                    width="635"
                    height="500"
                    className="img-fluid border-rad_10"
                    src={singleImg08}
                    alt="image"
                  />
                </div>
                {/* prt_single_image-wrapper end */}
              </div>
            </div>
          </div>
        </section>
        {/* about-section2 end */}
        {/* aboutservice-section4 */}
        <section className="prt-row padding_zero-section aboutservice-section clearfix" style={{ marginTop: "200px" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-bg bg-base-grey aboutservice-block mt_135">
                  <div className="row">
                    <div className="col-lg-11 col-md-12 m-auto">
                      <div className="aboutservice-content">
                        <h3 className="title">TDS (Tattavam Divine Soul) USHA Kriya - Sattau Model- Exclusive </h3>
                        <p className="desc">
                          Consectetur adipisicing elit, sed do eiusmod tempor
                          incididunt ut labore et dolore magna aliqua. Ut enim
                          ad minim veniam, quis nostrud exercitation ullamco
                          laboris nisi ut aliquip ex ea commodo consequat. Duis
                          aute irure dolor in reprehenderit. adipisicing elit,
                          sed do eiusmod tempor incididunt ut labore et dolore
                          magna aliqua. Ut enim ad minim veniam, quis nostrud
                          exercitation ullamco.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* aboutservice-section4 end */}
        {/* about-section 2*/}
        <section className="prt-row padding_bottom_zero-section about-section02 animation clearfix">
          <div className="container">
            <div className="row align-items-center">
              {/* FULL-WIDTH TITLE ROW */}
              <div className="row">
                <div className="col-12">
                  <div className="section-title text-center">
                    <div className="title-header">
                      <h2 className="title"> TDS (Tattavam Divine Soul) USHA Kriya</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12">
                <div>
                  {/* section title */}
                  <div className="section-title">
                    {/*<div className="title-header">
                      <h2 className="title">
                       विशेष आयुर्वेदिक चिकित्सा (Special Ayurvedic Therapies)
                       </h2>
                    </div>*/}
                    <div className="title-desc">
                      <h3 className="title">USHA Kriya – Towards Omkara, Swadhyaya & Sattayu / ओंकार, स्वाध्याय और सततायु की ओरgi</h3>
                      <p>
                        <b>USHA Kriya – Created and Perfected by Bhai Brahm Prashant</b><br></br>
                        A five-step Panch-Tatva healing practice revealed during the sacred Narmada Parikrama (2020), uniting mantra chanting, rhythmic clapping, acupressure, joint activation, and organ awakening.<br></br><br></br>

                        <b>The Five Steps of USHA Kriya</b><br></br>
                        • <b>Naam Japa with Clapping</b> – Activate energy, improve circulation, uplift joy.<br></br>
                        • <b>Six Types of Clapping</b> – Stimulate nerves, joints, and energy pathways.<br></br>
                        • <b>Finger &amp; Thumb Pressure</b> – Sharpen focus, balance nadis, boost immunity.<br></br>
                        • <b>Finger Joint Rubbing</b> – Improve organ function, flexibility, and energy flow.<br></br>
                        • <b>Pressing 19 Vital Points</b> – Awaken body-temple and channel prana.<br></br><br></br>

                        <b>The Complete Sequence</b><br></br>
                        Offer Arka to Surya Deva → Trataka → Sukshma Vyayam → Surya Namaskar → Panch-Tatva Sadhana → Core USHA Kriya.<br></br><br></br>

                        <b>Recognition</b><br></br>
                        Saints and masters affirm: “Not only beneficial for humanity but essential for the entire creation.”<br></br>
                        Regular practice protects from physical, cosmic, and material suffering.<br></br>
                        The solution to life’s challenges lies in one profound practice — USHA Kriya.<br></br><br></br>

                        <b>Essence &amp; Benefits</b><br></br>
                        • <b>11 Days Practice</b>: planetary balance, chakra awakening, Panch-Tatva harmony, dosha transformation.<br></br>
                        • Journey towards <b>Omkara, Swadhyaya, and Sattayu</b> (a long, healthy, conscious life).<br></br>
                        • <b>USHA Kriya is Bhajan</b> – the song of devotion &amp; awakening.<br></br>
                        • <b>Food is Bhog</b> – the sacred offering that sustains the body.<br></br>
                      </p>

                    </div>
                  </div>
                  {/* section title end 
                  <ul className="prt-list prt-list-style-icon-03">
                    <li className="prt-list-li-content">
                      Sed do eiusmod tempor incididunt ut labore et dolore magna{" "}
                    </li>
                    <li className="prt-list-li-content">
                      Ut enim ad minim veniam, quis nostrud exercitation
                    </li>
                    <li className="prt-list-li-content">
                      Laboris nisi ut aliquip ex ea commodo consequat duis{" "}
                    </li>
                    <li className="prt-list-li-content">
                      dolor in reprehenderit in voluptate velit esse cillum
                      dolore
                    </li>
                  </ul>*/}
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12">
                {/* prt_single_image-wrapper */}
                <div className="prt_single_image-wrapper text-center res-1199-mt-30 faderight-anim">
                  <img
                    width="635"
                    height="500"
                    className="img-fluid border-rad_10"
                    src={singleImg08}
                    alt="image"
                  />
                </div>
                {/* prt_single_image-wrapper end */}
              </div>
            </div>
          </div>
        </section>
        {/* about-section2 end */}
        {/* aboutservice-section5 */}
        <section className="prt-row padding_zero-section aboutservice-section clearfix" style={{ marginTop: "200px" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-bg bg-base-grey aboutservice-block mt_135">
                  <div className="row">
                    <div className="col-lg-11 col-md-12 m-auto">
                      <div className="aboutservice-content">
                        <h3 className="title">Yoga & Healing Therapies</h3>
                        <p className="desc">
                          Consectetur adipisicing elit, sed do eiusmod tempor
                          incididunt ut labore et dolore magna aliqua. Ut enim
                          ad minim veniam, quis nostrud exercitation ullamco
                          laboris nisi ut aliquip ex ea commodo consequat. Duis
                          aute irure dolor in reprehenderit. adipisicing elit,
                          sed do eiusmod tempor incididunt ut labore et dolore
                          magna aliqua. Ut enim ad minim veniam, quis nostrud
                          exercitation ullamco.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* aboutservice-section5 end */}
        {/* about-section 3*/}
        <section className="prt-row padding_bottom_zero-section about-section02 animation clearfix">
          <div className="container">
            <div className="row align-items-center">
              {/* FULL-WIDTH TITLE ROW */}
              <div className="row">
                <div className="col-12">
                  <div className="section-title text-center">
                    <div className="title-header">
                      <h2 className="title"> योग एवं हीलिंग थैरेपीज़ (Yoga & Healing Therapies)</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12">
                <div>
                  {/* section title */}
                  <div className="section-title">
                    {/*<div className="title-header">
                      <h2 className="title">
                       विशेष आयुर्वेदिक चिकित्सा (Special Ayurvedic Therapies)
                       </h2>
                    </div>*/}
                    <div className="title-desc">
                      <h3 className="title">योग एवं हीलिंग थैरेपीज़ (Yoga & Healing Therapies)</h3>
                      <p>
                        • <b>योग चिकित्सा एवं ध्यान सत्र</b> – Yoga therapy & meditation sessions.<br></br>
                        • <b>प्राणिक हीलिंग (Pranic Healing)</b> – Energy balancing with life-force.<br></br>
                        • <b>रेकी (Reiki)</b> – Japanese energy healing practice.<br></br>
                        • <b>क्रिस्टल हीलिंग (Crystal Healing)</b> – Healing through crystals & vibrations.<br></br>
                        • <b>Distance Healing</b> – Energy healing from afar.<br></br>
                        • <b>Energy Scanning</b> – Aura / bio-energy field assessment.<br></br>
                        • <b>अग्निहोत्र चिकित्सा (Agnihotra Therapy)</b> – Fire ritual detox & healing.<br></br>
                        • <b>यज्ञ चिकित्सा (Yajna Therapy)</b> – Vedic purification therapy.<br></br>
                        • <b>Zero Volt Therapy</b> – Electro-balancing therapy.<br></br>
                      </p>
                    </div>
                  </div>
                  {/* section title end 
                  <ul className="prt-list prt-list-style-icon-03">
                    <li className="prt-list-li-content">
                      Sed do eiusmod tempor incididunt ut labore et dolore magna{" "}
                    </li>
                    <li className="prt-list-li-content">
                      Ut enim ad minim veniam, quis nostrud exercitation
                    </li>
                    <li className="prt-list-li-content">
                      Laboris nisi ut aliquip ex ea commodo consequat duis{" "}
                    </li>
                    <li className="prt-list-li-content">
                      dolor in reprehenderit in voluptate velit esse cillum
                      dolore
                    </li>
                  </ul>*/}
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12">
                {/* prt_single_image-wrapper */}
                <div className="prt_single_image-wrapper text-center res-1199-mt-30 faderight-anim">
                  <img
                    width="635"
                    height="500"
                    className="img-fluid border-rad_10"
                    src={singleImg08}
                    alt="image"
                  />
                </div>
                {/* prt_single_image-wrapper end */}
              </div>
            </div>
          </div>
        </section>
        {/* about-section3 end */}
        {/* aboutservice-section6 */}
        <section className="prt-row padding_zero-section aboutservice-section clearfix" style={{ marginTop: "200px" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-bg bg-base-grey aboutservice-block mt_135">
                  <div className="row">
                    <div className="col-lg-11 col-md-12 m-auto">
                      <div className="aboutservice-content">
                        <h3 className="title">Exclusive Bharat Dhara Therapies</h3>
                        <p className="desc">
                          Consectetur adipisicing elit, sed do eiusmod tempor
                          incididunt ut labore et dolore magna aliqua. Ut enim
                          ad minim veniam, quis nostrud exercitation ullamco
                          laboris nisi ut aliquip ex ea commodo consequat. Duis
                          aute irure dolor in reprehenderit. adipisicing elit,
                          sed do eiusmod tempor incididunt ut labore et dolore
                          magna aliqua. Ut enim ad minim veniam, quis nostrud
                          exercitation ullamco.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* aboutservice-section6 end */}
        {/* about-section 4*/}
        <section className="prt-row padding_bottom_zero-section about-section02 animation clearfix">
          <div className="container">
            <div className="row align-items-center">
              {/* FULL-WIDTH TITLE ROW */}
              <div className="row">
                <div className="col-12">
                  <div className="section-title text-center">
                    <div className="title-header">
                      <h2 className="title"> Marma Therapy</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12">
                <div>
                  {/* section title */}
                  <div className="section-title">
                    {/*<div className="title-header">
                      <h2 className="title">
                       विशेष आयुर्वेदिक चिकित्सा (Special Ayurvedic Therapies)
                       </h2>
                    </div>*/}
                    <div className="title-desc">
                      <h3 className="title">योग एवं हीलिंग थैरेपीज़ (Yoga & Healing Therapies)</h3>
                      <p>
                        <b>विशेषीकृत चिकित्सा (Specialized Bharat Dhara Therapies)</b><br></br>
                        • <b>Varicose Veins Specialized Therapy</b> – For vein health & circulation.<br></br>
                        • <b>Body Alignment Therapy</b> – Posture & musculoskeletal correction.<br></br>
                        • <b>Upper Limb Node Therapy</b> – Specialized therapy for arms.<br></br>
                        • <b>Lower Limb Node Therapy (Pada Abhyanga)</b> – Specialized therapy for legs/feet.<br></br>
                      </p>

                    </div>
                  </div>
                  {/* section title end 
                  <ul className="prt-list prt-list-style-icon-03">
                    <li className="prt-list-li-content">
                      Sed do eiusmod tempor incididunt ut labore et dolore magna{" "}
                    </li>
                    <li className="prt-list-li-content">
                      Ut enim ad minim veniam, quis nostrud exercitation
                    </li>
                    <li className="prt-list-li-content">
                      Laboris nisi ut aliquip ex ea commodo consequat duis{" "}
                    </li>
                    <li className="prt-list-li-content">
                      dolor in reprehenderit in voluptate velit esse cillum
                      dolore
                    </li>
                  </ul>*/}
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 col-md-12">
                {/* prt_single_image-wrapper */}
                <div className="prt_single_image-wrapper text-center res-1199-mt-30 faderight-anim">
                  <img
                    width="635"
                    height="500"
                    className="img-fluid border-rad_10"
                    src={singleImg08}
                    alt="image"
                  />
                </div>
                {/* prt_single_image-wrapper end */}
              </div>
            </div>
          </div>
        </section>
        {/* about-section4 end */}
        {/* service-section */}
        <section className="prt-row service-section02 clearfix ml-15 mr-15 res-991-ml-0 res-991-mr-0">
          <div className="container-fluid">
            <div
              className="row row-equal-height slick_slider"
              data-slick='{"slidesToShow": 4, "slidesToScroll": 1, "arrows":false, "dots":false, "autoplay":true, "infinite":true, "responsive": [{"breakpoint":1400,"settings":{"slidesToShow": 3}},{"breakpoint":980,"settings":{"slidesToShow": 2}},{"breakpoint":656,"settings":{"slidesToShow": 1}}]}'
            >
              {/* Repeat these blocks for each service */}
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                <div className="featured-imagebox featured-imagebox-service style1">
                  <div className="featured-thumbnail">
                    <img
                      width="303"
                      height="151"
                      className="img-fluid"
                      src={service01}
                      alt="img"
                    />
                  </div>
                  <div className="featured-content">
                    <div className="featured-title">
                      <h3>
                        <a href="service-details.html">General medicine</a>
                      </h3>
                    </div>
                    <div className="featured-desc">
                      <p>( Kayachikitsa )</p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Add other services similarly */}
            </div>
          </div>
        </section>
        {/* service-section end */}

        {/* pricing-plan-section */}
        <section className="prt-row padding_top_zero-section pricing-plan-section prt-pricingbox-style1 animation clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-7">
                <div className="section-title">
                  <div className="title-header">
                    <h2 className="title">Price and plans</h2>
                  </div>
                  <div className="title-desc pricing-desc">
                    <p>
                      <img
                        width="24"
                        height="24"
                        className="img-fluid"
                        src={icon05}
                        alt="image"
                      />{" "}
                      Explore competitive pricing and flexible plans{" "}
                      <a
                        className="prt-btn btn-inline prt-btn-size-md prt-btn-color-darkcolor underline p-0"
                        href="contact-us.html"
                      >
                        Make appointment
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="title-desc">
                  <p>
                    Discover transparent pricing and flexible plans to meet
                    diverse needs. From budget-friendly options to comprehensive
                    packages, we cater to every requirement
                  </p>
                </div>
              </div>
            </div>

            {/* Pricing cards */}
            <div className="row prt-boxes-row-wrapper fadeup-amin">
              <div className="prt-box-col-wrapper col-xl-4 col-lg-12 active">
                <div className="featured-pricingplan-style1 img-one">
                  <div className="featured-box-info">
                    <div className="featured-pricing-content">
                      <div className="prt-p_table-body">
                        <div className="prt-p_table-title">
                          <h3>Free</h3>
                          <p>Plan with premium features</p>
                        </div>
                        <div className="prt-p_table-amount">
                          <span className="cur_symbol"></span>$45
                          <span className="pac_frequency">/ mo</span>
                        </div>
                      </div>
                      <ul className="prt-p_table-features">
                        <li>Get the brain ultrasound </li>
                        <li>Get the chest xray </li>
                        <li>Get the femur xray </li>
                        <li>Get the pelvic ultrasound </li>
                      </ul>
                      <div className="prt-pricing-btn">
                        <a
                          className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor"
                          href="contact-us.html"
                        >
                          Buy Now
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Add other plans similarly */}
            </div>
          </div>
        </section>
        {/* pricing-plan-section end */}

        {/* info-section */}
        <section className="prt-row padding_zero-section prt-bg bg-base-skin info-section clearfix">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-md-12">
                <div className="prt-info-main-block">
                  <div className="info_btn mr-30 res-767-mb-15">
                    <a
                      className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor"
                      href="#"
                    >
                      COVID-19 resources
                    </a>
                  </div>
                  <div className="featured-icon-box icon-align-before-content style2">
                    <div className="featured-icon">
                      <div className="prt-icon prt-icon_element-onlytxt prt-icon_element-size-lg prt-icon_element-color-darkcolor">
                        <i className="flaticon-alert"></i>
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h3>Get The Health package</h3>
                      </div>
                      <div className="featured-desc">
                        <p>
                          What you need to know about the 2019 - 2023 fly
                          season.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* info-section end */}
      </div>
      {/* site-main end */}
    </>
  );
}
